import React from "react";
import { useDispatch } from "react-redux";
import { updateProjectMemoryPenalties, updateTitleMemoryPenalties } from "../../../redux/ducks/memory";

const SetMemoryPenalty = props => {

    const dispatch = useDispatch();

    return (
        <button className={"button button--cold " + (props.memories.length > 0 ? "" : "button--disabled")} onClick={e => {
            let penalty = prompt("Enter penalty amount:");
            if (!penalty) return;

            if (props.titleID != undefined) {
                dispatch(updateTitleMemoryPenalties({ penalty, memoryIDs: props.memories, titleID: props.titleID }));
            } else if (props.projectID != undefined) {
                dispatch(updateProjectMemoryPenalties({ penalty, memoryIDs: props.memories, projectID: props.projectID }));
            }
        }}>Set Penalty</button>
    )
}

export default SetMemoryPenalty;